import { PermissionsService } from '@shared';

export function providePermissions(permission: PermissionsService) {
  return () => {
    permission.loadPermissionsFromToken();
  };
}
